import React, { useState } from 'react'
import { message } from 'antd'

const WorkstationSettings = () => {
    const [station, setStation] = useState(localStorage.getItem('station') ?? '')

    const save = () => {
        localStorage.setItem('station', station)
        message.success('Workstation settings have been saved')
    }

    return (
        <div className="w-full max-w-xl">
            <h2 className="font-semibold text-gray-800 text-lg mb-1">Workstation Settings</h2>
            <p className="text-xs text-gray-500 mb-4">
                Applies only to this browser/computer, not the whole system. Used to label which
                station a bill/order came from.
            </p>
            <div className="flex flex-wrap -mx-3 mb-3">
                <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-station">
                        Station Name
                    </label>
                    <input
                        id="grid-station"
                        value={station}
                        onChange={e => setStation(e.target.value)}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        placeholder="X-Ray" />
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={save} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                    Save Changes
                </button>
            </div>
        </div>
    )
}

export default WorkstationSettings
